export default __webpack_public_path__ + "static/media/1019.085aba43.png";